import { useQuery, useQueryClient } from '@tanstack/react-query'
import React, { useEffect, useMemo, useState } from 'react'
import { Button, Col, Container, Form, FormControl, InputGroup, OverlayTrigger, Row, Spinner, Table, Tooltip } from 'react-bootstrap'
import { useSelector } from 'react-redux'
import { useHistory } from 'react-router-dom'

import { useApprovePackageRequest, useRejectPkgReq } from '../../../../api/package-req'
import { getUnitedPackageData } from '../../../../api/package-req/packageReqService'
import { getFullUrl } from '../../../../helpers/files'
import vIcon from '../../../../imgs/check.png'
import xIcon from '../../../../imgs/remove.png'
import { QUERY_KEYS } from '../../../../lib/queryKeys'
import { uploadReceipt } from '../../../../services/files'
import Sticker from '../../Sticker/Sticker'
const twoDecimals = num => {
  return Math.floor(num * 100) / 100
}
const inchToCm = num => {
  return twoDecimals(Math.floor((num || 0) * 2.54 * 100) / 100)
}
const cmToInch = num => {
  return Math.floor(((num || 0) / 2.54) * 100) / 100
}
const kgToPound = num => {
  return Math.floor(((num || 0) / 0.4535923) * 100) / 100
}
const poundToKg = num => {
  return Math.floor((num || 0) * 0.4535923 * 100) / 100
}
const isNotNumber = num => {
  return isNaN(parseFloat(num))
}
export default function UniteRequestDetails(props) {
  const { item } = props
  const { loggedUser } = useSelector(state => state.user)
  const queryClient = useQueryClient()
  const [subPackagesConfirmObj, setSubPackagesConfirmObj] = useState({})
  const [isLoading, updateIsLoading] = useState(false)
  const [isPrinting, updateIsPrinting] = useState(false)
  const history = useHistory()
  const { data } = useQuery({
    queryKey: [QUERY_KEYS.UNITE_PACKAGE, item.id],
    queryFn: () => getUnitedPackageData(item.id),
  })

  const { unitedPackage, packagesToUnite } = data?.data || {}
  const { mutateAsync: approvePackageReq, isPending: isSending } = useApprovePackageRequest()
  const { mutateAsync: rejectPackageReq, isPending: isRejecting } = useRejectPkgReq()
  const [buyingReciptKey, setBuyingReciptKey] = useState('')
  const [height, setHeight] = useState(0)

  const [width, setWidth] = useState(0)

  const [length, setLength] = useState(0)

  const [weight, setWeight] = useState(0)

  const warehouse = unitedPackage?.warehouse

  const formError = useMemo(() => {
    if (!width || !height || !length || !weight) {
      return 'please insert package size'
    }
  }, [width, height, length, weight])
  const onBack = () => {
    history.goBack()
  }
  useEffect(() => {
    if (unitedPackage) {
      setSubPackagesConfirmObj(packagesToUnite.reduce((acc, p) => ({ ...acc, [p.trackingNumberToIsrael]: false }), {}))
      setHeight(warehouse === 'USA' ? cmToInch(unitedPackage.height) : unitedPackage.height)
      setWidth(warehouse === 'USA' ? cmToInch(unitedPackage.width) : unitedPackage.width)
      setLength(warehouse === 'USA' ? cmToInch(unitedPackage.length) : unitedPackage.length)
      setWeight(warehouse === 'USA' ? kgToPound(unitedPackage.weight) : unitedPackage.weight)
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [unitedPackage])

  const getLinkUrlForItem = async itemKey => {
    if (!itemKey) return
    const url = getFullUrl(itemKey)
    window.open(url, '_blank')
  }

  const submitUnitedPackageOp = async () => {
    //check if the scanned packages are the correct packages
    let packagesChecker = Object.values(subPackagesConfirmObj).every(v => v == true)
    if (!packagesChecker) {
      alert('Wrong packages scanned!')
      return
    }
    const validHeight = parseFloat(height)
    const validWidth = parseFloat(width)
    const validLength = parseFloat(length)
    const validWeight = parseFloat(weight)
    if (isNotNumber(validHeight) || isNotNumber(validWidth) || isNotNumber(validLength) || isNotNumber(validWeight)) {
      alert('Please insert valid package dimensions')
      return
    }
    const newDimensions = {
      height: warehouse === 'USA' ? inchToCm(validHeight) : validHeight,
      width: warehouse === 'USA' ? inchToCm(validWidth) : validWidth,
      length: warehouse === 'USA' ? inchToCm(validLength) : validLength,
      weight: warehouse === 'USA' ? poundToKg(validWeight) : validWeight,
    }
    //check if the package volWeight is more than 20KG
    if ((newDimensions.height * newDimensions.length * newDimensions.width) / 5000 >= 20 || newDimensions.weight >= 20) {
      alert(
        `Package weight or volumetric weight is over 20! => ${(newDimensions.height * newDimensions.length * newDimensions.width) / 5000}`
      )
      return
    }

    try {
      const approvalData = {
        packageReqId: item.id,
        newDimensions,
        uniteReceiptUrl: buyingReciptKey,
      }

      const approvalResult = await approvePackageReq(approvalData)

      if (approvalResult.statusCode === 200) {
        queryClient.invalidateQueries({ queryKey: [QUERY_KEYS.UNITE_PACKAGE, item.id] })
        updateIsPrinting(true)
      } else {
        throw new Error('Failed to approve unite request')
      }
    } catch (error) {
      console.error('submitUnitedPackageOp - error:', error)
      alert('Failed to approve unite request')
    }
  }

  const handleAfterPrint = async () => {
    updateIsPrinting(false)

    onBack()
  }

  const getPackageIdTail = packageId => packageId.slice(packageId.length - 6, packageId.length)

  const fileUploadHandler = async e => {
    const file = e.target.files[0]

    try {
      updateIsLoading(true)
      const uploaded = await uploadReceipt(file, item.id)

      setBuyingReciptKey(uploaded.Location)
      updateIsLoading(false)
    } catch (error) {
      console.log('fileUploadHandler - error:', error)
      alert(`Error! ${error.response.data?.msg}`)
    }
  }

  const onCancelUniteRequest = async (uniteObj, rejectReason) => {
    const isConfirmed = window.confirm('Are you sure you want to cancel unite request?')
    if (!isConfirmed) return

    try {
      await rejectPackageReq({ packageReqId: uniteObj.id, rejectReason })
      onBack()
    } catch (error) {
      console.log('Error while trying to cancel unite request', error)
    }
  }

  const xltInputHandler = (inputXlt, pXlt) => {
    if (inputXlt.length != 12) return

    if (inputXlt == pXlt) {
      setSubPackagesConfirmObj({ ...subPackagesConfirmObj, [pXlt]: true })
    } else {
      setSubPackagesConfirmObj({ ...subPackagesConfirmObj, [pXlt]: false })
    }
  }

  const copyToClipboard = str => {
    navigator.clipboard.writeText(str)
  }

  if (isSending || isRejecting || !unitedPackage || !packagesToUnite) {
    return (
      <div className='package-requests-cmp'>
        Loading... <br />
        <Spinner animation='border' variant='primary' />
      </div>
    )
  }

  return (
    <>
      {isPrinting ? (
        <Sticker
          data={{
            name: unitedPackage.costumer_firstName + ' ' + unitedPackage.costumer_LastName,
            unit: unitedPackage.unit,
            trackingNumberToIsrael: unitedPackage.trackingNumberToIsrael,
            brand: unitedPackage.brand,
            address:
              unitedPackage.shippingAdress_adress +
              ' ' +
              unitedPackage.shippingAdress_apartmentNumber +
              ' ' +
              unitedPackage.shippingAdress_city +
              ' ' +
              unitedPackage.shippingAdress_postalCode,
          }}
          handleAfterPrint={handleAfterPrint}
        />
      ) : (
        <div>
          <div className='d-flex justify-content-center align-items-center mb-4'>
            <h2>Unite Package</h2>
            <Button variant='danger' size='sm' className='btn-icon ml-4' onClick={onBack}>
              X
            </Button>
          </div>
          <Row>
            <Col>
              <Table>
                <thead>
                  <tr>
                    <th>Xlt</th>
                    <th>Brand</th>
                    <th>Height</th>
                    <th>Width</th>
                    <th>Weight</th>
                    <th>Content</th>
                    <th>Price</th>
                    <th style={{ textAlign: 'center' }}>Receipt</th>
                    <th>Location</th>
                  </tr>
                </thead>

                <tbody>
                  {packagesToUnite.map(item => {
                    return (
                      <tr key={item.id}>
                        <td>{getPackageIdTail(item.trackingNumberToIsrael)}</td>
                        <td> {item.brand} </td>
                        <td> {item.height} </td>
                        <td> {item.width} </td>
                        <td> {item.weight} </td>
                        <td>
                          {' '}
                          {item?.contents?.map((c, i) => {
                            return (
                              <span key={c.productCategory}>
                                {i > 0 && ', '}
                                {c.productCategory} X {c.quantity}
                              </span>
                            )
                          })}{' '}
                        </td>
                        <td> {item.price} </td>
                        <td>
                          <Button disabled={!item.buyingReciptKey} variant='link' onClick={() => getLinkUrlForItem(item.buyingReciptKey)}>
                            Download
                          </Button>
                        </td>
                        <td>{item.warehouseLocation ? item.warehouseLocation : 'none'}</td>
                      </tr>
                    )
                  })}
                </tbody>
              </Table>
            </Col>
          </Row>
          <Container>
            <Row style={{ marginTop: '50px' }}>
              <Col>
                <Form id='addPackageForm'>
                  <Form.Group controlId='exampleForm.ControlInput1'></Form.Group>
                  <Form.Group>
                    <div style={{ display: 'flex' }}>
                      <Form.Group controlId='exampleForm.ControlInput1'>
                        <Form.Label>Unit</Form.Label>
                        <Form.Control disabled type='text' placeholder={unitedPackage.unit} />
                      </Form.Group>
                      <Form.Group controlId='exampleForm.ControlInput1' style={{ flexGrow: '1' }}>
                        <Form.Label>Costumer ID</Form.Label>
                        <Form.Control disabled type='text' placeholder={unitedPackage.costumer} />
                      </Form.Group>
                      <Form.Group controlId='exampleForm.ControlInput1'>
                        <Form.Label>Costumer Email</Form.Label>
                        <Form.Control disabled type='email' placeholder={unitedPackage.costumer_Email} />
                      </Form.Group>
                      <Form.Group controlId='exampleForm.ControlInput1'>
                        <Form.Label>Costumer Name</Form.Label>
                        <Form.Control
                          disabled
                          type='text'
                          placeholder={unitedPackage.costumer_firstName + ' ' + unitedPackage.costumer_LastName}
                        />
                      </Form.Group>
                    </div>

                    <Form.Group controlId='exampleForm.ControlInput1'>
                      <Form.Label>Box Size</Form.Label>
                      <div style={{ display: 'flex', alignItems: 'center' }}>
                        <Form.Group controlId='exampleForm.ControlInput2'>
                          <Form.Label>Height {warehouse === 'USA' ? '(INCH)' : '(CM)'}</Form.Label>
                          <Form.Control
                            onChange={e => setHeight(e.target.value)}
                            name='height'
                            type='number'
                            step='any'
                            value={height}
                            onWheel={e => e.target.blur()} // Prevent scroll from changing the value
                          />

                          {warehouse === 'USA' && (
                            <>
                              <Form.Label>Height (CM)</Form.Label>
                              <Form.Control name='height' type='number' step='any' value={inchToCm(height)} disabled />
                            </>
                          )}
                        </Form.Group>

                        <Form.Group controlId='exampleForm.ControlInput3'>
                          <Form.Label>Width {warehouse === 'USA' ? '(INCH)' : '(CM)'}</Form.Label>
                          <Form.Control
                            onChange={e => setWidth(e.target.value)}
                            name='width'
                            type='number'
                            step='any'
                            value={width}
                            onWheel={e => e.target.blur()} // Prevent scroll from changing the value
                          />
                          {warehouse === 'USA' && (
                            <>
                              <Form.Label>Width (CM)</Form.Label>
                              <Form.Control name='width' type='number' step='any' value={inchToCm(width)} disabled />
                            </>
                          )}
                        </Form.Group>

                        <Form.Group controlId='exampleForm.ControlInput4'>
                          <Form.Label>Length {warehouse === 'USA' ? '(INCH)' : '(CM)'}</Form.Label>
                          <Form.Control
                            onChange={e => setLength(e.target.value)}
                            name='length'
                            type='number'
                            step='any'
                            value={length}
                            onWheel={e => e.target.blur()} // Prevent scroll from changing the value
                          />

                          {warehouse === 'USA' && (
                            <>
                              <Form.Label>Length (CM)</Form.Label>
                              <Form.Control name='length' type='number' step='any' value={inchToCm(length)} disabled />
                            </>
                          )}
                        </Form.Group>

                        <Form.Group controlId='exampleForm.ControlInput5'>
                          <Form.Label>Weight {warehouse === 'USA' ? '(Pound)' : '(KG)'}</Form.Label>
                          <Form.Control
                            onChange={e => setWeight(e.target.value)}
                            name='weight'
                            type='number'
                            step='any'
                            value={weight}
                            onWheel={e => e.target.blur()} // Prevent scroll from changing the value
                          />

                          {warehouse === 'USA' && (
                            <>
                              <Form.Label>Weight (KG)</Form.Label>
                              <Form.Control name='weight' type='number' step='any' value={poundToKg(weight)} disabled />
                            </>
                          )}
                        </Form.Group>
                      </div>
                    </Form.Group>

                    <InputGroup className='mb-3'>
                      <Form.Label>Receipt:</Form.Label>
                      <InputGroup.Prepend>
                        <InputGroup.Text id='inputGroup-sizing-default'>
                          {isLoading ? <Spinner animation='border' variant='primary' /> : ' Choose File...'}
                        </InputGroup.Text>
                      </InputGroup.Prepend>
                      <FormControl
                        type='file'
                        aria-label='Default'
                        aria-describedby='inputGroup-sizing-default'
                        onChange={e => fileUploadHandler(e)}
                      />
                    </InputGroup>

                    <Form.Group controlId='exampleForm.ControlTextarea1'>
                      <Form.Label>Package Content</Form.Label>
                      <Form.Control
                        disabled
                        type='text'
                        as='textarea'
                        rows={3}
                        placeholder={unitedPackage.contents?.map(v => `${v.productCategory} * ${v.quantity}`).join(', ')}
                      />
                    </Form.Group>
                  </Form.Group>
                </Form>
              </Col>
            </Row>
            {packagesToUnite.map((p, idx) => {
              return (
                <div className='uniteform-xlt-cont' key={idx}>
                  <OverlayTrigger
                    placement='bottom'
                    overlay={
                      <Tooltip>
                        {' '}
                        <span>Click to copy</span>{' '}
                      </Tooltip>
                    }
                  >
                    <div onClick={() => copyToClipboard(p.trackingNumberToIsrael)}>{p.trackingNumberToIsrael} :</div>
                  </OverlayTrigger>
                  <input
                    type='text'
                    onChange={e => {
                      xltInputHandler(e.target.value, p.trackingNumberToIsrael)
                    }}
                  />
                  {subPackagesConfirmObj[p.trackingNumberToIsrael] ? <img src={vIcon} height='30px' /> : <img src={xIcon} height='30px' />}
                </div>
              )
            })}
            <Row>
              <Col>
                <Button onClick={submitUnitedPackageOp} disabled={formError || isSending}>
                  Unite
                </Button>
              </Col>
            </Row>
            <div className='reject-reqs-cont'>
              <h4>Reject Request</h4>

              <div className='reject-req-cards-cont' style={{ marginBottom: '50px' }}>
                <div className='reject-req-card'>
                  <div style={{ fontWeight: 'bold' }}>United Package Too Big/Heavy</div>
                  <div>Cant unite packages because the united package is too big or heavy.</div>
                  <Button
                    variant='danger'
                    style={{ backgroundColor: 'red' }}
                    onClick={() => onCancelUniteRequest(item, 'tooHeavy')}
                    disabled={loggedUser.permissions['Worker']}
                  >
                    Reject
                  </Button>
                </div>
                <div className='reject-req-card'>
                  <div style={{ fontWeight: 'bold' }}>Fragile Package</div>
                  <div>Cant unite the packages because the item is too fragile.</div>
                  <Button
                    variant='danger'
                    style={{ backgroundColor: 'red' }}
                    onClick={() => onCancelUniteRequest(item, 'fragile')}
                    disabled={loggedUser.permissions['Worker']}
                  >
                    Reject
                  </Button>
                </div>
              </div>
            </div>
          </Container>
        </div>
      )}
    </>
  )
}
